import { render, staticRenderFns } from "./CompanySearchNew.vue?vue&type=template&id=16a18229&scoped=true&"
import script from "./CompanySearchNew.vue?vue&type=script&lang=js&"
export * from "./CompanySearchNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__l_2143961a9b56ebcf8368d5c80e6c319f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a18229",
  null
  
)

export default component.exports